// extracted by mini-css-extract-plugin
export default {"icon":"category-icon_icon__xHhI-"};